import template from './datasets-time-filter-step2.hbs'
import _ from 'lodash'
import DatasetFilterStep from './datasets-filter-step'
import setupDateTimeRangeAutoFix from 'scoreboard/datasets/filters/setup-datetime-range-autofix'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import deleteNonApplicableFilterProperties from './delete-non-applicable-filter-properties'
import momentHelper from 'scoreboard/components/moment-helper'
import valuesOrEquationsTemplate from 'scoreboard/datasets/filters/datasets-datetime-values-or-equations.hbs'
import { renderValueOrEquations } from './value-or-equation'
import formHelper from 'scoreboard/components/form-helper'
import DataType from 'scoreboard/datasets/model/data-type'
const { TIME } = DataType

const DatasetsTimeFilterStep2 = DatasetFilterStep.extend({

	className: DatasetFilterStep.prototype.className + ' datasets-time-filter-step2',

	template,

	/**
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model
	 *
	 * @param {Object} options.filter
	 *
	 * @param {FilterWizard} [options.wizard]
	 *
	 * @param {Boolean} [options.new=false]
	 */
	initialize: function(options) {
		this.options = options || {}
		this.field =
			this.options.model.combinedFieldsById[this.options.filter.fieldId]

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: true
		})
	},

	render: function() {
		this.$el.empty().append(this.template(this.context()))
		this.renderTimeFilterControls()
		const hide2ndInput = !this._isBetweenDateTime()
		this.$('.between-filter').toggleClass('is-not-displayed', hide2ndInput)

		this.options.wizard && this.options.wizard.render({
			el: this.el,
			stateSaver: () => this.saveState()
		})

		this.formView.start({
			isNew: this.options.new
		})

		return this
	},

	renderTimeFilterControls() {
		this._insertValueOrEquationsMarkup()
		const timeDisplayType = _.result(this.field, 'timeDisplayType')
		this.valueOrEquations = renderValueOrEquations({
			dataType: TIME,
			model: this.model,
			filter: this.options.filter,
			formView: this.formView,
			field: this.field,
			el: this.$el,
			allowCalculated: this.options.allowCalculated,
			selector: '.time-value-or-equation',
			hour24: momentHelper.is24hrTimeType(timeDisplayType),
			timeDisplayType
		})

		const controls = [
			this.valueOrEquations[0].markedField,
			this.valueOrEquations[1].markedField
		]
		setupDateTimeRangeAutoFix(controls, dt => {
			const bothManual = this.$('[name=updateType1]').val() === 'manual' &&
				this.$('[name=updateType2]').val() === 'manual'
			return bothManual && dt.isBeingRemoved
		})
	},

	_insertValueOrEquationsMarkup: function() {
		const firstInputLabel = this._isBetweenDateTime() ?
			i18n.get('report.customReport.filter.from') :
			i18n.get(`common.time`)
		this.$('.panel-content').append(valuesOrEquationsTemplate({
			firstInputLabel,
			type: TIME,
			namePrefix: TIME,
			classes: `time-filter`
		}))
	},

	_isBetweenDateTime: function() {
		return this.options.filter.operator === 'between-date-time'
	},

	context: function() {
		let c = DatasetFilterStep.prototype.context.apply(this, arguments)
		return _.extend({}, c, {
			between: this._isBetweenDateTime()
		})
	},

	saveState() {
		const fromDom = formHelper.readFromDom(this.el)
		_.extend(this.options.filter, fromDom)

		deleteNonApplicableFilterProperties(this.options.filter, 'time')

		return this.options.filter
	},

	remove: function() {
		DatasetFilterStep.prototype.remove.apply(this, arguments)
		_.invokeMap(this.valueOrEquations, 'remove')
	}
})

export default DatasetsTimeFilterStep2

DatasetsTimeFilterStep2.__filename__ = 'datasets/filters/datasets-time-filter-step2.js'
